const SYMBOL = "/brand/logo-symbol-transparent.png";

const SIZES = { xs: 22, sm: 28, md: 36, lg: 56, xl: 96 };

export const BrandSymbol = ({ size = "md", className = "", alt = "Símbolo da Erimus" }) => (
  <img
    src={SYMBOL}
    alt={alt}
    width={SIZES[size] || size}
    height={SIZES[size] || size}
    data-testid="brand-symbol"
    className={`object-contain ${className}`}
    style={{ height: SIZES[size] || size, width: "auto" }}
  />
);

/** Lockup oficial: símbolo + palavra Erimus, com legenda opcional do produto. */
export const BrandLockup = ({
  size = "md",
  product,
  orientation = "horizontal",
  tone = "light",
  testId = "brand-lockup",
}) => {
  const word = tone === "dark" ? "text-white" : "text-sage-600";
  const sub = tone === "dark" ? "text-white/70" : "text-ink-500";
  const wordSize = { xs: "text-sm", sm: "text-base", md: "text-lg", lg: "text-2xl", xl: "text-3xl" }[size] || "text-lg";

  if (orientation === "vertical") {
    return (
      <span data-testid={testId} className="flex flex-col items-center gap-2 text-center">
        <BrandSymbol size={size} />
        <span className={`font-display font-bold leading-none ${wordSize} ${word}`}>Erimus</span>
        {product ? <span className={`text-xs ${sub}`}>{product}</span> : null}
      </span>
    );
  }

  return (
    <span data-testid={testId} className="flex items-center gap-2.5">
      <BrandSymbol size={size} />
      <span className="flex flex-col leading-tight">
        <span className={`font-display font-bold ${wordSize} ${word}`}>Erimus</span>
        {product ? <span className={`text-[11px] ${sub}`}>{product}</span> : null}
      </span>
    </span>
  );
};
